import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function fullNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const nameFormat = /^[A-Za-zА-Яа-яЁёӘІҢҒҮҰҚӨҺәіңғүұқөһ'-]{2,}$/;
    const initialPattern = /^[А-ЯЁA-Z]\.$/;
    const combinedInitialsRe = /^[А-ЯЁA-Z]\.[А-ЯЁA-Z]\.$/;
    const raw = control.value?.trim() || "";
    if (!raw) {
      return null;
    }

    const parts = raw.split(/\s+/);
    if (parts.length < 2 || parts.length > 3) {
      return { fullNameNotValid: true };
    }

    for (let i = 0; i < parts.length; i++) {
      const p = parts[i];
      if (i === 0) {
        if (!nameFormat.test(p)) {
          return { fullNameNotValid: true };
        }
      } else {
        if (!initialPattern.test(p) && !combinedInitialsRe.test(p) && !nameFormat.test(p)) {
          return { fullNameNotValid: true };
        }
      }
    }

    return null;
  };
}
